import React from "react";
import { m } from "framer-motion";
import Portrait from "./Portrait";
import type { ChatCopy } from "./copy";

interface ChatTeaserProps {
  copy: ChatCopy;
  reducedMotion: boolean;
  onOpen: () => void;
  onDismiss: () => void;
}

/** The speech bubble above the launcher. Shown once per session; a click opens the panel. */
const ChatTeaser: React.FC<ChatTeaserProps> = ({ copy, reducedMotion, onOpen, onDismiss }) => (
  <m.div
    initial={reducedMotion ? { opacity: 0 } : { opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0 }}
    transition={{ duration: reducedMotion ? 0 : 0.25 }}
    role="region"
    aria-label={copy.launcher}
    data-chat-teaser="1"
    data-print="hide"
    className="fixed z-[9990] w-[min(21.25rem,calc(100vw-2rem))] right-4 bottom-[calc(max(1rem,env(safe-area-inset-bottom))+4.5rem)] sm:right-6 sm:bottom-24"
  >
    <div className="relative p-3 pr-12 border rounded-lg border-border bg-surface-raised shadow-2">
      <button
        type="button"
        onClick={onOpen}
        className="flex items-center w-full gap-3 text-left rounded-md"
      >
        <Portrait size={40} />
        <span className="text-sm leading-relaxed text-primary">{copy.teaser}</span>
      </button>
      <button
        type="button"
        onClick={onDismiss}
        aria-label={copy.teaserClose}
        className="absolute right-1 top-1 flex h-11 w-11 items-center justify-center rounded-full text-muted hover:bg-surface-sunken hover:text-primary"
      >
        <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      {/* Tail toward the launcher */}
      <div aria-hidden="true" className="absolute w-4 h-4 rotate-45 border-b border-r -bottom-2 right-8 border-border bg-surface-raised" />
    </div>
  </m.div>
);

export default ChatTeaser;
